import { Tooltip, useMantineTheme, type TooltipProps } from '@mantine/core';
import { ReactNode } from 'react';

type AppTooltipProps = Omit<TooltipProps, 'label' | 'children'> & {
  label: ReactNode;
  children: ReactNode;
  maxWidth?: number;
  inline?: boolean;
};

export function AppTooltip({
  label,
  children,
  maxWidth = 320,
  inline = false,
  withArrow = true,
  withinPortal = true,
  ...props
}: AppTooltipProps) {
  const theme = useMantineTheme();
  const styles = {
    tooltip: {
      backgroundColor: theme.colorScheme === 'dark' ? '#000' : '#fff',
      border: `1px solid ${theme.colorScheme === 'dark' ? '#333' : '#ddd'}`,
      borderRadius: 10,
      color: theme.colorScheme === 'dark' ? '#fff' : '#000',
      padding: '10px 12px',
      maxWidth,
      fontSize: 13,
      lineHeight: 1.35,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
    arrow: {
      border: `1px solid ${theme.colorScheme === 'dark' ? '#333' : '#ddd'}`,
    },
  } as const;

  const content = inline ? (
    <span style={{ display: 'inline-flex', width: 'fit-content', maxWidth: '100%' }}>{children}</span>
  ) : (
    children
  );

  return (
    <Tooltip label={label} withArrow={withArrow} withinPortal={withinPortal} styles={styles} {...props}>
      {content}
    </Tooltip>
  );
}
